<script>
import SkeletonLoader from '@components/skeleton-loader.vue'

export default {
  components: { SkeletonLoader },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    hasCard: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <SkeletonLoader :class="isMobile ? $style.cardImageContainerMobile : $style.cardImageContainer" />
    <SkeletonLoader v-if="hasCard" :class="$style.appDescription" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-direction: column;
}

.cardImageContainer {
  width: 193px;
  height: 107px;
  margin-bottom: 8px;
}

.cardImageContainerMobile {
  width: 98px;
  height: 98px;
  margin-bottom: 8px;
}

.appDescription {
  width: 98px;
  height: 22px;
}
</style>
